import {
  CREATE_MIXINGPLANT_REQUEST,
  CREATE_MIXINGPLANT_ERROR,
  CREATE_MIXINGPLANT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => async (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITY_REQUEST = CREATE_MIXINGPLANT_REQUEST;
  context.CREATE_ENTITY_ERROR = CREATE_MIXINGPLANT_ERROR;
  context.CREATE_ENTITY_SUCCESS = CREATE_MIXINGPLANT_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixingPlant";
  context.entityLocation = RESOURCES.MixingPlants;
  context.hasOrganisation = true;

  return context.execute(context)(entity)(state, action);
};